import { Linkedin, Twitter, Youtube, Mail } from "lucide-react"
import Link from "next/link"

export default function Footer() {
  return (
    <footer className="py-12 sm:py-16 bg-[#020617] border-t border-white/5 font-[family-name:var(--font-plus-jakarta-sans)]">
      <div className="max-w-[1800px] mx-auto px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-center md:text-left">
          {/* Brand Section */}
          <div className="space-y-6 lg:col-span-1">
            <Link
              href="/"
              className="text-[32px] font-bold text-white tracking-tight leading-none font-[family-name:var(--font-league-spartan)] hover:text-white/90 transition-colors inline-block"
            >
              Rakesh Gohel
            </Link>
            <div className="space-y-4">
              <p className="text-base text-white/70 leading-relaxed">
                Pioneering the future of Agentic AI and autonomous systems.
              </p>
              <p className="text-sm text-white/60 leading-relaxed">
                Architecting production-ready AI agent workflows for enterprise-scale transformation.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6 md:pl-8 lg:pl-12">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-3">
              {['About', 'Agentic AI', 'Book', 'Contact'].map((item) => (
                <li key={item}>
                  <a
                    href={item === 'About' ? '/' : item === 'Agentic AI' ? '/#LinkedInSocialProof' : item === 'Book' ? '/#book' : item === 'Contact' ? '/#contact' : `/#LinkedInSocialProof`}
                    className="text-sm sm:text-base text-white/70 hover:text-blue-400 transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="space-y-6 md:pl-4">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Connect</h3>
            <div className="flex justify-center md:justify-start gap-4">
              <a
                href="https://www.linkedin.com/in/rakeshgohel01"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:text-blue-400 hover:border-blue-400 transition-all duration-300 group"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
              <a
                href="https://twitter.com/rakeshgohel01"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:text-blue-400 hover:border-blue-400 transition-all duration-300 group"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
              <a
                href="https://www.youtube.com/@gohelrakesh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:text-blue-400 hover:border-blue-400 transition-all duration-300 group"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
              <a
                href="mailto:info@juteq.ca"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:text-blue-400 hover:border-blue-400 transition-all duration-300 group"
                aria-label="Email"
              >
                <Mail className="w-5 h-5 group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>

          {/* Contact Us */}
          <div className="space-y-6 md:pl-4">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Contact Us</h3>
            <div className="space-y-4 text-sm sm:text-base text-white/70">
              <div className="space-y-1">
                <p>
                  <span className="text-white font-medium">Phone:</span> +1 647 250 7414
                </p>
                <p>
                  <span className="text-white font-medium">Email:</span> info@juteq.ca
                </p>
              </div>
              <div className="pt-2">
                <p className="text-white font-medium">Canada</p>
                <p>600 Matheson Blvd W Unit 5</p>
                <p>Mississauga, ON L5R 4B8</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60" suppressHydrationWarning>
              © {new Date().getFullYear()} Rakesh Gohel. All rights reserved.
            </p>
            <div className="flex gap-4 text-sm text-white/60">
              <Link href="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link>
              <Link href="/terms" className="hover:text-blue-400 transition-colors">Terms of Service</Link>
              <Link href="/content-use" className="hover:text-blue-400 transition-colors">Content Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
